document.addEventListener("DOMContentLoaded", function () {
  const slider = document.querySelector(".featured-collection__content");
  if (slider) {
    const flickity = new Flickity(slider, {
      cellAlign: "left",
      contain: true,
      pageDots: false,
      prevNextButtons: false,
    });

    const dots = document.querySelectorAll(".slider-dots .dot");
    flickity.on("change", function (index) {
      dots.forEach((dot) => dot.classList.remove("active"));
      if (dots[index]) {
        dots[index].classList.add("active");
      }
    });

    dots.forEach((dot, index) => {
      dot.addEventListener("click", () => {
        flickity.select(index);
      });
    });
  }
});

// Accordion footer menu
document.addEventListener("DOMContentLoaded", function () {
  const title = document.getElementById("footer-rich-text-title");
  const content = document.getElementById("footer-rich-text-content");
  const icon = document.getElementById("chevron-icon");
  function isMobile() {
    return window.innerWidth <= 768;
  }

  if (title && content && icon) {
    if (isMobile()) {
      title.addEventListener("click", function () {
        if (content.style.display === "none" || content.style.display === "") {
          content.style.display = "block";

          icon.innerHTML = `
            <svg aria-hidden="true" focusable="false" role="presentation" width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path class="icon-chevron-up-left" d="M7 1.25L12.5 6.75" stroke="currentColor" stroke-width="1.75" stroke-linecap="square"></path>
              <path class="icon-chevron-up-right" d="M7 1.25L1.5 6.75" stroke="currentColor" stroke-width="1.75" stroke-linecap="square"></path>
            </svg>
          `;
        } else {
          content.style.display = "none";

          icon.innerHTML = `
            <svg aria-hidden="true" focusable="false" role="presentation" width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path class="icon-chevron-down-left" d="M7 6.75L12.5 1.25" stroke="currentColor" stroke-width="1.75" stroke-linecap="square"></path>
              <path class="icon-chevron-down-right" d="M7 6.75L1.5 1.25" stroke="currentColor" stroke-width="1.75" stroke-linecap="square"></path>
            </svg>
          `;
        }
      });
    }
  }
});

// Size Guide Popup
document.addEventListener("DOMContentLoaded", function () {
  const openButton = document.getElementById("mm-size-guide-btn");
  const popup = document.getElementById("mm-size-guide-popup");
  const overlay = document.getElementById("mm-overlay");
  const closeButton = document.getElementById("mm-close-popup");

  function openPopup() {
    popup.style.display = "block";
    overlay.style.display = "block";
  }

  function closePopup() {
    popup.style.display = "none";
    overlay.style.display = "none";
  }

  if (openButton) {
    openButton.addEventListener("click", openPopup);
  }

  if (closeButton) {
    closeButton.addEventListener("click", closePopup);
  }

  if (overlay) {
    overlay.addEventListener("click", closePopup);
  }
});

// Product Gallery Dot Navigation
document.addEventListener("DOMContentLoaded", function () {
  const galleryViewer = document.querySelector("[data-gallery-viewer]");
  const dots = document.querySelectorAll("[data-gallery-dot]");
  const figures = document.querySelectorAll("[data-gallery-figure]");

  function updateActiveDot(activeIndex) {
    dots.forEach((dot, index) => {
      if (index === activeIndex) {
        dot.setAttribute("aria-current", "true");
      } else {
        dot.setAttribute("aria-current", "false");
      }
    });
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const activeIndex = Array.from(figures).indexOf(entry.target);
          updateActiveDot(activeIndex);
        }
      });
    },
    {
      root: galleryViewer,
      threshold: 0.5,
    }
  );

  figures.forEach((figure) => {
    observer.observe(figure);
  });

  dots.forEach((dot, index) => {
    dot.addEventListener("click", () => {
      const targetFigure = figures[index];
      targetFigure.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "center",
      });

      updateActiveDot(index);
    });
  });
});

// Search Popup
document.getElementById("mm-search-btn").addEventListener("click", function () {
  var searchContent = document.getElementById("mm-search-content");
  var overlay = document.createElement("div");
  overlay.id = "mm-overlay";
  overlay.style.position = "fixed";
  overlay.style.top = 0;
  overlay.style.left = 0;
  overlay.style.width = "100%";
  overlay.style.height = "100%";
  overlay.style.backgroundColor = "rgba(0, 0, 0, 0.6)";
  overlay.style.zIndex = 999;

  document.body.appendChild(overlay);

  searchContent.style.display = "flex";

  overlay.addEventListener("click", function () {
    searchContent.style.display = "none";
    document.body.removeChild(overlay);
  });
});

// Rotate the menu icon in filters
document.addEventListener("click", function (e) {
  const parentLink = e.target.closest(".navmenu-link-parent");

  if (parentLink) {
    const expanded = parentLink.getAttribute("aria-expanded") === "true";
    parentLink.setAttribute("aria-expanded", !expanded);
  }
});

//  Rotate the menu icon in filters group
document.querySelectorAll("[data-filter-group-trigger]").forEach((button) => {
  button.addEventListener("click", () => {
    const isExpanded = button.getAttribute("aria-expanded") === "true";
    button.setAttribute("aria-expanded", !isExpanded);
  });
});

// Calling a chat from a custom button in the mobile menu
document
  .getElementById("mobile-nav__footer--chat")
  .addEventListener("click", function () {
    document.getElementById("Avada-FAQ_WidgetTrigger").click();
  });

// FOR LINK BOXES ARROWS
//  document.addEventListener("DOMContentLoaded", function () {
//   const containerConfigs = [
//     {
//       wrapperSelector: ".link-boxes-container",
//       scrollSelector: ".link-boxes_wrapper"
//     },
//     {
//       wrapperSelector: ".custom-link-boxes-wrapper",
//       scrollSelector: ".metafield-rich_text_field"
//     }
//   ];

//   containerConfigs.forEach(({ wrapperSelector, scrollSelector }) => {
//     const wrappers = document.querySelectorAll(wrapperSelector);

//     wrappers.forEach(wrapper => {
//       const scrollContainer = wrapper.querySelector(scrollSelector);
//       const prevBtn = wrapper.querySelector(".button-prev");
//       const nextBtn = wrapper.querySelector(".button-next");

//       if (!scrollContainer || !prevBtn || !nextBtn) return;

//       // Ensure scroll styling
//       scrollContainer.style.overflowX = "auto";
//       scrollContainer.style.whiteSpace = "nowrap";

//       const scrollAmount = 200;

//       prevBtn.addEventListener("click", () => {
//         scrollContainer.scrollBy({ left: -scrollAmount, behavior: "smooth" });
//       });

//       nextBtn.addEventListener("click", () => {
//         scrollContainer.scrollBy({ left: scrollAmount, behavior: "smooth" });
//       });
//     });
//   });
// });


//   document.addEventListener('DOMContentLoaded', function () {
//     const headerSticky = document.querySelector('.site-header-main');

//     if (!headerSticky) return;

//     window.addEventListener('scroll', function () {
//       if (window.innerWidth <= 768) {
//         if (window.scrollY > 150) {
//           headerSticky.classList.add('sticky-header-mob');
//         } else {
//           headerSticky.classList.remove('sticky-header-mob');
//         }
//       } else {
//         // Ensure sticky is removed on desktop
//         headerSticky.classList.remove('sticky-header-mob');
//       }
//     });
//   });

